/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Faq_Changepassword_Body2Inputs */

const en_usermanagement_help_faq_changepassword_body2 = /** @type {(inputs: Usermanagement_Help_Faq_Changepassword_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your password directly through our Single-Sign-On provider Okta. Log out of the Investor portal and click on "Forgot password" during the sign-in flow. You will be sent a link from Okta to change your password.`)
};

/**
* | output |
* | --- |
* | "Update your password directly through our Single-Sign-On provider Okta. Log out of the Investor portal and click on \"Forgot password\" during the sign-in flow..." |
*
* @param {Usermanagement_Help_Faq_Changepassword_Body2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_faq_changepassword_body2 = /** @type {((inputs?: Usermanagement_Help_Faq_Changepassword_Body2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Faq_Changepassword_Body2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_faq_changepassword_body2(inputs)
});
export { usermanagement_help_faq_changepassword_body2 as "userManagement_help_faq_changePassword_body" }